import { useState, useCallback } from 'react';
import type { IUseFormErrorProps } from '../types';

const MAX_FORM_RETRIES = 3;

export const useFormError = ({ formCreated }: IUseFormErrorProps) => {
  const [retryAttempt, setRetryAttempt] = useState(0);

  const handleFormError = useCallback(() => {
    if (retryAttempt < MAX_FORM_RETRIES) {
      setRetryAttempt(prev => prev + 1);
      formCreated.current = false; // Reset form creation flag
      return true; // Indicates retry should happen
    } else {
      console.error('Max retry attempts reached for form creation');
      return false; // Indicates no more retries
    }
  }, [retryAttempt, formCreated]);

  return { retryAttempt, handleFormError };
}; 
